module.exports={
    backEndUrl: process.env.BACKEND_URL || "https://survey-backend-cp5k.onrender.com/"
}